<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="showLabel?label:''"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <InputNumber
      :min="min"
      style="width: 100%;"
      :value="value"
      :placeholder="placeholder?placeholder:label"
      :readonly="readonly"
      :disabled="disabled"
      :step="step"
      @on-change="onInputChange"
      :precision="precision"
      @on-blur="onInputBlur"
    />
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaNumberInput',

  mixins: [inputMixin],

  data() {
    return {
      type: 'number',
    }
  },

  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    min: Number,
    step: Number,
    // max属性原本没有，但是有人加了，还加了字符串类型（在离接收一下减少报错）
    max: [String, Number],
    placeholder: String,
  },

  watch: {
    value(v) {
      if (this.step) {
        var num = String(this.step).split('.')[1].length;
        var bl = Math.pow(10, num);
        var val = Math.ceil(Number(this.value) * bl) / bl
        this.value = val
      }
    }
  }
}
</script>
